import { Performance as CampaignPerformance } from '../types/CampaignPerformance';

const toCampaignPerformance = (campaignPerformance: CampaignPerformance): CampaignPerformance => {
    return { ...campaignPerformance };
};

export { toCampaignPerformance };
